import { Injectable, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { NotificationService } from './notification.service';
import { HttpClient } from '@angular/common/http';
import { CodePostalDto, ParametresGlobauxDto, ParcDto, PaysDto, PictogrammeDto, CategorieDocumentDto, TypeConteneurMobileDto, TypeConteneurValues, TypeDechetDto, TypeDechetRwdto, TypeDechetValues, TypePersonnePhysiqueValues, TypeTelephone, UniteMesureDto, ZoneGeographiqueDto, TypeAccesPersonneMoraleDto, FormeJuridiqueDto, DemandeManutentionStatutValues, TransporteurDto, DispatchExutoireDto, DispatchTransporteurDto, TypeArticle, EmplacementStockDto, CommandeStatut, TypeIntervention, StatutIntervention, TypeReleveCompteur, Langues, StatutRapportPrepose, EvacuationStatut, TypeEvacuationDto, InterventionDto, StatutNettoyage, NettoyageDto, TypeDegatValues, TypeElementStockDto } from 'src/api/models';
import { ControlPanel } from 'src/states/control-panel.actions';
import { EnvService } from 'src/environments/environment';

@Injectable()
export class PanelLayoutService implements OnDestroy {
  MaxCharacters = 120;

  @Select(ControlPanelStore.authToken$) authToken$: Observable<string>;
  @Select(ControlPanelStore.logo$) logo$: Observable<any>;
  @Select(ControlPanelStore.codesPostaux$) codesPostaux$: Observable<CodePostalDto[]>;
  @Select(ControlPanelStore.pays$) pays$: Observable<PaysDto[]>;
  @Select(ControlPanelStore.typesDechets$) typesDechets$: Observable<TypeDechetDto[]>;
  @Select(ControlPanelStore.typesDechetsRW$) typesDechetsRW$: Observable<TypeDechetRwdto[]>;
  @Select(ControlPanelStore.unitesMesure$) unitesMesure$: Observable<UniteMesureDto[]>;
  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;
  @Select(ControlPanelStore.zonesGeographiques$) zonesGeographiques$: Observable<ZoneGeographiqueDto[]>;
  @Select(ControlPanelStore.typesConteneursMobiles$) typesConteneursMobile$: Observable<TypeConteneurMobileDto[]>;
  @Select(ControlPanelStore.pictogrammes$) pictogrammes$: Observable<PictogrammeDto[]>;
  @Select(ControlPanelStore.categoriesDocument$) categoriesDocument$: Observable<CategorieDocumentDto[]>;
  @Select(ControlPanelStore.typesAcces$) typeAcces$: Observable<TypeAccesPersonneMoraleDto[]>;
  @Select(ControlPanelStore.formesJuridiques$) formesJuridiques$: Observable<FormeJuridiqueDto[]>;
  @Select(ControlPanelStore.transporteurs$) transporteurs$: Observable<TransporteurDto[]>;
  @Select(ControlPanelStore.dispatchExutoires$) dispatchExutoires$: Observable<DispatchExutoireDto[]>;
  @Select(ControlPanelStore.dispatchTransporteurs$) dispatchTransporteurs$: Observable<DispatchTransporteurDto[]>;
  @Select(ControlPanelStore.emplacements$) emplacements$: Observable<EmplacementStockDto[]>;
  @Select(ControlPanelStore.typesEvacuations$) typesEvacuations$: Observable<TypeEvacuationDto[]>;
  @Select(ControlPanelStore.typesElementsStock$) typesElementsStock$: Observable<TypeElementStockDto[]>;

  private ActiveHeaderFilter: any;
  private DefaultHeaderFilter: any;
  private ConteneurMobileHeaderFilter: any;
  private PersonnePhysiqueHeaderFilter: any;
  private EstExcluHeaderFilter: any;
  private SecondeResidenceHeaderFilter: any;
  private DechetTypeHeaderFilter: any;
  private TypeDechetIdHeaderFilter: any;
  private ParcHeaderFilter: any;
  private StatutRapportHeaderFilter: any
  private DechetTypeSelection: any;
  private ConteneurTypeSelection: any;
  private LangueSelection: any;
  private TypeTelephoneSelection: any;
  private TauxRemplissageSelection: any;
  private TypeAccesFilter: any;
  private FormeJuridiqueFilter: any;
  private DemandeManutentionStatut: any;
  private DemandeManutentionStatutFilter: any;
  private TypeArticleFilter: any;
  private TypeArticle: any;
  private TypeCompteurFilter: any;
  private EmplacementHeaderFilter: any;
  private StatutCommande: any;
  private StatutCommandeFilter: any;
  private TypeInterventionFilter: any;
  private TypeDegatFilter: any;
  private StatutInterventionFilter: any;
  private StatutNettoyageFilter: any;
  private StatutEvacuationFilter: any;
  private TypeEvacuationIdHeaderFilter: any;
  private TypeElementStockFilter: any;

  private Translations: any;

  logo: any;
  codesPostaux: CodePostalDto[];
  pays: PaysDto[];
  typesDechets: TypeDechetDto[];
  typesDechetsRW: TypeDechetRwdto[];
  unitesMesure: UniteMesureDto[];
  parcs: ParcDto[];
  zonesGeographiques: ZoneGeographiqueDto[];
  typesConteneursMobiles: TypeConteneurMobileDto[];
  pictogrammes: PictogrammeDto[];
  categoriesDocument: CategorieDocumentDto[];
  typesAcces: TypeAccesPersonneMoraleDto[];
  formesJuridiques: FormeJuridiqueDto[];
  transporteurs: TransporteurDto[];
  dispatchExutoires: DispatchExutoireDto[];
  dispatchTransporteurs: DispatchTransporteurDto[];
  emplacements: EmplacementStockDto[];
  typesEvacuations: TypeEvacuationDto[];
  typesElementsStock: TypeElementStockDto[];

  a: Subscription;
  l: Subscription;
  cp: Subscription;
  p: Subscription;
  td: Subscription;
  tdrw: Subscription;
  um: Subscription;
  pa: Subscription;
  zg: Subscription;
  tc: Subscription;
  pi: Subscription;
  cd: Subscription;
  ta: Subscription;
  fj: Subscription;
  tr: Subscription;
  de: Subscription;
  dt: Subscription;
  e: Subscription;
  te: Subscription;
  tes: Subscription;

  constructor(private translate: TranslateService,
    private notificationService: NotificationService,
    private envService: EnvService,
    private store: Store,
    private http: HttpClient) {
    this.store.dispatch(new ControlPanel.GetLogo());

    this.a = this.authToken$.subscribe(res => {
      if (res != null) {
        this.store.dispatch(new ControlPanel.GetCodesPostaux());
        this.store.dispatch(new ControlPanel.GetPays());
        this.store.dispatch(new ControlPanel.GetTypesDechet());
        this.store.dispatch(new ControlPanel.GetTypesDechetRW());
        this.store.dispatch(new ControlPanel.GetUnitesMesure());
        this.store.dispatch(new ControlPanel.GetParcs());
        this.store.dispatch(new ControlPanel.GetExutoires());
        this.store.dispatch(new ControlPanel.GetConteneurs());
        this.store.dispatch(new ControlPanel.GetConteneursMobiles());
        this.store.dispatch(new ControlPanel.GetZonesGeographiques());
        this.store.dispatch(new ControlPanel.GetTypesConteneurs());
        this.store.dispatch(new ControlPanel.GetPictogrammes());
        this.store.dispatch(new ControlPanel.GetTypesIncidents());
        this.store.dispatch(new ControlPanel.GetCategoriesDocuments());
        this.store.dispatch(new ControlPanel.GetFormesJuridiques());
        this.store.dispatch(new ControlPanel.GetTypesAcces());
        this.store.dispatch(new ControlPanel.GetTransporteurs());
        this.store.dispatch(new ControlPanel.GetDispatchExutoires());
        this.store.dispatch(new ControlPanel.GetDispatchTransporteurs());
        this.store.dispatch(new ControlPanel.GetEmplacements());
        this.store.dispatch(new ControlPanel.GetArticles());
        this.store.dispatch(new ControlPanel.GetTypesEvacuations());
        this.store.dispatch(new ControlPanel.GetAllParams());
        this.store.dispatch(new ControlPanel.GetThemes());
        this.store.dispatch(new ControlPanel.GetTypesElementsStock());
      }
    });

    this.l = this.logo$.subscribe(imageBlob => {
      if (imageBlob != null) {
        if (imageBlob.type != null) {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.logo = reader.result;
          }, false);
          if (imageBlob) {
            reader.readAsDataURL(imageBlob);
          }
        }
      }
    });

    this.cp = this.codesPostaux$.subscribe(res => {
      if (res != null) {
        this.codesPostaux = res;
      }
    });

    this.p = this.pays$.subscribe(res => {
      if (res != null) {
        this.pays = res.sort((a,b) => (a.Nom > b.Nom) ? 1 : ((b.Nom > a.Nom) ? -1 : 0));
      }
    });

    this.td = this.typesDechets$.subscribe(res => {
      if (res != null) {
        this.typesDechets = res.filter(t => t.EstActif).sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));
        this.TypeDechetIdHeaderFilter = this.typesDechets.map(td => {
          return {
            text: td.Designation,
            value: ['', '=', td.Id]
          };
        } );
      }
    });

    this.tdrw = this.typesDechetsRW$.subscribe(res => {
      if (res != null) {
        this.typesDechetsRW = res;
      }
    });

    this.um = this.unitesMesure$.subscribe(res => {
      if (res != null) {
        this.unitesMesure = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
      }
    });

    this.pa = this.parcs$.subscribe(res => {
      if (res != null) {
        this.parcs = res;
        this.ParcHeaderFilter = this.parcs.map(p => {
          //p.Identifiant = p.Identifiant[0] + p.Identifiant.substring(1).toLowerCase();
          return p;
        }).sort((p1, p2) => p1.Identifiant.localeCompare(p2.Identifiant)).map(td => {
          return {
            text: td.Identifiant,
            value: ['', '=', td.Id]
          };
        });
      }
    });

    this.e = this.emplacements$.subscribe(res => {
      if (res != null) {
        this.emplacements = res;
        this.EmplacementHeaderFilter = this.emplacements.map(p => {
          //p.Identifiant = p.Identifiant[0] + p.Identifiant.substring(1).toLowerCase();
          return p;
        }).sort((e1, e2) => e1.Nom.localeCompare(e2.Nom)).map(td => {
          return {
            text: td.Nom,
            value: ['', '=', td.Id]
          };
        });
      }
    });

    this.zg = this.zonesGeographiques$.subscribe(res => {
      if (res != null) {
        this.zonesGeographiques = res.sort((a,b) => (a.Nom > b.Nom) ? 1 : ((b.Nom > a.Nom) ? -1 : 0));;
      }
    });

    this.tc = this.typesConteneursMobile$.subscribe(res => {
      if (res != null) {
        this.typesConteneursMobiles = res.sort((a,b) => (a.Nom > b.Nom) ? 1 : ((b.Nom > a.Nom) ? -1 : 0));;
      }
    });

    this.pi = this.pictogrammes$.subscribe(res => {
      if (res != null) {
        this.pictogrammes = res;
      }
    });

    this.cd = this.categoriesDocument$.subscribe(res => {
      if (res != null) {
        this.categoriesDocument = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
      }
    });

    this.tr = this.transporteurs$.subscribe(res => {
      if (res != null) {
        this.transporteurs = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
      }
    });

    this.de = this.dispatchExutoires$.subscribe(res => {
      if (res != null) {
        this.dispatchExutoires = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
      }
    });

    this.dt = this.dispatchTransporteurs$.subscribe(res => {
      if (res != null) {
        this.dispatchTransporteurs = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
      }
    });

    this.ta = this.typeAcces$.subscribe(res => {
      if (res != null) {
        this.typesAcces = res;
        this.TypeAccesFilter = this.typesAcces.map(p => {
          //p.Identifiant = p.Identifiant[0] + p.Identifiant.substring(1).toLowerCase();
          return p;
        }).sort((p1, p2) => p1.Identifiant.localeCompare(p2.Identifiant)).map(td => {
          return {
            text: td.Identifiant,
            value: ['', '=', td.Id]
          };
        } );
      }
    });

    this.fj = this.formesJuridiques$.subscribe(res => {
      if (res != null) {
        this.formesJuridiques = res;
        this.FormeJuridiqueFilter = this.formesJuridiques.map(p => {
          //p.Identifiant = p.Identifiant[0] + p.Identifiant.substring(1).toLowerCase();
          return p;
        }).sort((p1, p2) => p1.Identifiant.localeCompare(p2.Identifiant)).map(td => {
          return {
            text: td.Identifiant,
            value: ['', '=', td.Id]
          };
        } );
      }
    });

    this.te = this.typesEvacuations$.subscribe(res => {
      if (res != null) {
        this.typesEvacuations = res;
        this.TypeEvacuationIdHeaderFilter = this.typesEvacuations.map(t => {
          return t;})
          .sort((t1,t2) => t1.Identifiant.localeCompare(t2.Identifiant)).map(t => {
            return {
              text: t.Identifiant,
              value: ['', '=', t.Id]
          };
        });
      }
    });

    this.tes = this.typesElementsStock$.subscribe(res => {
      if (res != null) {
        this.typesElementsStock = res;
        this.TypeElementStockFilter = this.typesElementsStock.map(t => {
          return t;})
          .sort((t1,t2) => t1.Nom.localeCompare(t2.Nom)).map(t => {
            return {
              text: t.Nom,
              value: ['', '=', t.Id]
          };
        });
      }
    });
  }

  ngOnDestroy() {
    this.e?.unsubscribe();
    this.a?.unsubscribe();
    this.l?.unsubscribe();
    this.cp?.unsubscribe();
    this.p?.unsubscribe();
    this.td?.unsubscribe();
    this.tdrw?.unsubscribe();
    this.um?.unsubscribe();
    this.pa?.unsubscribe();
    this.zg?.unsubscribe();
    this.tc?.unsubscribe();
    this.pi?.unsubscribe();
    this.cd?.unsubscribe();
    this.ta?.unsubscribe();
    this.fj?.unsubscribe();
    this.tr?.unsubscribe();
    this.de?.unsubscribe();
    this.dt?.unsubscribe();
    this.te?.unsubscribe();
    this.tes?.unsubscribe();
  }

  LoadTranslation(): Observable<any> {
    return this.translate.get(
      [
        'Yes',
        'No',
        'State.Active',
        'State.Inactive',
        'Conteneurs.TypesConteneurs.Fixe',
        'Conteneurs.TypesConteneurs.Mobile',
        'PhysicalPersons.TypesPP.Belge',
        'PhysicalPersons.TypesPP.Etranger',
        'TypesDechets.Types.MatiereAQuota',
        'TypesDechets.Types.MatiereAPointer',
        'TypesDechets.Types.MatiereARetrait',
        'Parcs.Detail.Phones.Types.Principal',
        'Parcs.Detail.Phones.Types.Mobile',
        'Parcs.Detail.Phones.Types.Bureau',
        'Parcs.Detail.Phones.Types.Autre',
        'Conteneurs.NiveauRemplissageValue.Empty',
        'Conteneurs.NiveauRemplissageValue.1/4',
        'Conteneurs.NiveauRemplissageValue.1/2',
        'Conteneurs.NiveauRemplissageValue.3/4',
        'Conteneurs.NiveauRemplissageValue.Full',
        'DemandeManutentionStatut.Annule',
        'DemandeManutentionStatut.Cloture',
        'DemandeManutentionStatut.EnAttente',
        'DemandeManutentionStatut.EnCours',
        'DemandeManutentionStatut.EnDemande',
        'DemandeManutentionStatut.Livre',
        'DemandeManutentionStatut.ACloturer',
        'Stock.Articles.Types.UtilisationInterne',
        'Stock.Articles.Types.PeutEtreVendu',
        'Stock.Commandes.Statuts.Brouillon',
        'Stock.Commandes.Statuts.Envoye',
        'Stock.Commandes.Statuts.Valide',
        'Stock.Commandes.Statuts.Prepare',
        'Stock.Commandes.Statuts.Livre',
        'Entretien.Interventions.Types.InterventionTechnique',
        'Entretien.Interventions.Types.Entretien',
        'Entretien.Interventions.Types.Tonte',
        'Entretien.Interventions.Types.ReparationConteneur',
        "Entretien.Interventions.Statuts.EnDemande",
        "Entretien.Interventions.Statuts.Validee",
        "Entretien.Interventions.Statuts.Planifiee",
        "Entretien.Interventions.Statuts.Effectuee",
        "Entretien.Interventions.Statuts.Annulee",
        'Entretien.Interventions.TypeDegats.PersonneInconnue',
        'Entretien.Interventions.TypeDegats.DegatsUsure',
        'Entretien.Interventions.TypeDegats.PersonneConnue',
        "Entretien.Nettoyage.Statuts.EnAttente",
        "Entretien.Nettoyage.Statuts.EnCours",
        "Entretien.Nettoyage.Statuts.Terminee",
        'Entretien.RelevesCompteurs.TypesCompteurs.Eau',
        'Entretien.RelevesCompteurs.TypesCompteurs.Electricite',
        'Entretien.RelevesCompteurs.TypesCompteurs.Gaz',
        'Entretien.RelevesCompteurs.TypesCompteurs.Mazout',
        'Rapports.RapportsPreposes.Statuts.Brouillon',
        'Rapports.RapportsPreposes.Statuts.Envoye',
        'Langues.Francais',
        'Langues.Anglais',
        'Langues.Allemand',
        'Langues.Neerlandais',
        'Evacuations.Statut.Ouverte',
        'Evacuations.Statut.Cloturee'
      ]
    ).pipe(tap(translations => {

      this.Translations = translations;

      this.DefaultHeaderFilter = [{
          text: translations['Yes'],
          value: ['', '=', true]
        }, {
          text: translations['No'],
          value: ['', '=', false]
        }
      ];
      this.ActiveHeaderFilter = [{
          text: translations['State.Active'],
          value: ['', '=', true]
        }, {
          text: translations['State.Inactive'],
          value: ['', '=', false]
        }
      ];
      this.ConteneurMobileHeaderFilter = [{
          text: translations['Conteneurs.TypesConteneurs.Fixe'],
          value: ['', '=', TypeConteneurValues.Fixe]
        }, {
          text: translations['Conteneurs.TypesConteneurs.Mobile'],
          value: ['', '=', TypeConteneurValues.Mobile]
        }
      ];
      this.PersonnePhysiqueHeaderFilter = [{
          text: translations['PhysicalPersons.TypesPP.Belge'],
          value: ['', '=', TypePersonnePhysiqueValues.Belge]
        }, {
          text: translations['PhysicalPersons.TypesPP.Etranger'],
          value: ['', '=', TypePersonnePhysiqueValues.Etranger]
        }
      ];
      this.SecondeResidenceHeaderFilter = [{
          text: translations['Yes'],
          value: ['SecondesResidences.Count', '>', 0]
        }, {
          text: translations['No'],
          value: ['SecondesResidences.Count', '=', 0]
        }
      ];
      this.DechetTypeHeaderFilter = [{
          text: translations['TypesDechets.Types.MatiereAQuota'],
          value: ['', '=', TypeDechetValues.MatiereAQuota]
        }, {
          text: translations['TypesDechets.Types.MatiereAPointer'],
          value: ['', '=', TypeDechetValues.MatiereAPointer]
        }, {
          text: translations['TypesDechets.Types.MatiereARetrait'],
          value: ['', '=', TypeDechetValues.MatiereARetrait]
        }
      ];
      this.DemandeManutentionStatutFilter = [{
          text: translations['DemandeManutentionStatut.EnAttente'],
          value: ['', '=', DemandeManutentionStatutValues.EnAttente]
        }, {
          text: translations['DemandeManutentionStatut.EnDemande'],
          value: ['', '=', DemandeManutentionStatutValues.EnDemande]
        }, {
          text: translations['DemandeManutentionStatut.EnCours'],
          value: ['', '=', DemandeManutentionStatutValues.EnCours]
        }, {
          text: translations['DemandeManutentionStatut.Livre'],
          value: ['', '=', DemandeManutentionStatutValues.Livre]
        }, {
          text: translations['DemandeManutentionStatut.Cloture'],
          value: ['', '=', DemandeManutentionStatutValues.Cloture]
        }, {
          text: translations['DemandeManutentionStatut.Annule'],
          value: ['', '=', DemandeManutentionStatutValues.Annule]
        }
      ];

      this.TypeArticleFilter = [{
          text: translations['Stock.Articles.Types.UtilisationInterne'],
          value: ['TypeArticle', '=', TypeArticle.UtilisationInterne]
        }, {
          text: translations['Stock.Articles.Types.PeutEtreVendu'],
          value: ['TypeArticle', '=', TypeArticle.PeutEtreVendu]
        }
      ];

      this.TypeCompteurFilter = [{
        text: translations['Entretien.RelevesCompteurs.TypesCompteurs.Eau'],
        value: ['Type', '=', TypeReleveCompteur.Eau]
        },{
        text: translations['Entretien.RelevesCompteurs.TypesCompteurs.Electricite'],
        value: ['Type', '=', TypeReleveCompteur.Electricite]
        },{
          text: translations['Entretien.RelevesCompteurs.TypesCompteurs.Gaz'],
          value: ['Type', '=', TypeReleveCompteur.Gaz]
        },{
          text: translations['Entretien.RelevesCompteurs.TypesCompteurs.Mazout'],
          value: ['Type', '=', TypeReleveCompteur.Mazout]
        },{
          text: translations['Entretien.RelevesCompteurs.TypesCompteurs.Compacteur'],
          value: ['Type', '=', TypeReleveCompteur.Compacteur]
          }
      ];

      this.StatutCommandeFilter = [{
          text: translations['Stock.Commandes.Statuts.Brouillon'],
          value: ['Statut', '=', CommandeStatut.Brouillon]
        }, {
          text: translations['Stock.Commandes.Statuts.Envoye'],
          value: ['Statut', '=', CommandeStatut.Envoye]
        }, {
          text: translations['Stock.Commandes.Statuts.Valide'],
          value: ['Statut', '=', CommandeStatut.Valide]
        }
      ];

      this.StatutRapportHeaderFilter = [{
          text: translations['Rapports.RapportsPreposes.Statuts.Brouillon'],
          value: ['Statut', '=', StatutRapportPrepose.Brouillon]
        }, {
          text: translations['Rapports.RapportsPreposes.Statuts.Envoye'],
          value: ['Statut', '=', StatutRapportPrepose.Envoye]
        }
      ];

      this.TypeInterventionFilter = [{
          text: translations['Entretien.Interventions.Types.InterventionTechnique'],
          value: ['', '=', TypeIntervention.InterventionTechnique]
        }, {
          text: translations['Entretien.Interventions.Types.Entretien'],
          value: ['', '=', TypeIntervention.Entretien]
        }, {
          text: translations['Entretien.Interventions.Types.Tonte'],
          value: ['', '=', TypeIntervention.Tonte]
        },
        {
          text: translations['Entretien.Interventions.Types.ReparationConteneur'],
          value: ['', '=', TypeIntervention.ReparationConteneur]
        }
      ];

      this.TypeDegatFilter = [{
          text: translations['Entretien.Interventions.TypeDegats.PersonneInconnue'],
          value: ['', '=', TypeDegatValues.PersonneInconnue]
        }, {
          text: translations['Entretien.Interventions.TypeDegats.DegatsUsure'],
          value: ['', '=', TypeDegatValues.DegatsUsure]
        }, {
          text: translations['Entretien.Interventions.TypeDegats.PersonneConnue'],
          value: ['', '=', TypeDegatValues.PersonneConnue]
        }
      ];

      this.StatutInterventionFilter = [
        {
          text: translations['Entretien.Interventions.Statuts.EnDemande'],
          value: ['', '=', StatutIntervention.EnDemande]
        }, {
          text: translations['Entretien.Interventions.Statuts.Validee'],
          value: ['', '=', StatutIntervention.Validee]
        }, {
          text: translations['Entretien.Interventions.Statuts.Planifiee'],
          value: ['', '=', StatutIntervention.Planifiee]
        }, {
          text: translations['Entretien.Interventions.Statuts.Effectuee'],
          value: ['', '=', StatutIntervention.Effectuee]
        }, {
          text: translations['Entretien.Interventions.Statuts.Annulee'],
          value: ['', '=', StatutIntervention.Annulee]
        }
      ];

      this.StatutNettoyageFilter = [
        {
          text: translations['Entretien.Nettoyage.Statuts.EnAttente'],
          value: ['', '=', StatutNettoyage.EnAttente]
        }, {
          text: translations['Entretien.Nettoyage.Statuts.EnCours'],
          value: ['', '=', StatutNettoyage.EnCours]
        }, {
          text: translations['Entretien.Nettoyage.Statuts.Terminee'],
          value: ['', '=', StatutNettoyage.Terminee]
        }
      ];

    this.StatutEvacuationFilter = [
      {
        text: translations['Evacuations.Statut.Cloturee'],
        value: ['', '=', EvacuationStatut.Cloturee]
      },
      {
        text: translations['Evacuations.Statut.Ouverte'],
        value: ['', '=', EvacuationStatut.Ouverte]
      }
    ];


      this.DechetTypeSelection = [
        { value: TypeDechetValues.MatiereAQuota, name: translations['TypesDechets.Types.MatiereAQuota'], icon: 'percent' },
        { value: TypeDechetValues.MatiereAPointer, name: translations['TypesDechets.Types.MatiereAPointer'], icon: 'checklist' },
        { value: TypeDechetValues.MatiereARetrait, name: translations['TypesDechets.Types.MatiereARetrait'], icon: 'export' },
      ];
      this.ConteneurTypeSelection = [
        { value: TypeConteneurValues.Fixe, name: translations['Conteneurs.TypesConteneurs.Fixe'], icon: 'pin' },
        { value: TypeConteneurValues.Mobile, name: translations['Conteneurs.TypesConteneurs.Mobile'], icon: 'runner' }
      ];
      this.LangueSelection = [
        { value: Langues.Francais, name: translations['Langues.Francais'] },
        { value: Langues.Anglais, name: translations['Langues.Anglais'] },
        { value: Langues.Allemand, name: translations['Langues.Allemand'] },
        { value: Langues.Neerlandais, name: translations['Langues.Neerlandais'] }
      ];
      this.TypeTelephoneSelection = [
        { value: TypeTelephone.Principal, name: translations['Parcs.Detail.Phones.Types.Principal'], icon: 'home' },
        { value: TypeTelephone.Mobile, name: translations['Parcs.Detail.Phones.Types.Mobile'], icon: 'tel' },
        { value: TypeTelephone.Bureau, name: translations['Parcs.Detail.Phones.Types.Bureau'], icon: 'product' },
        { value: TypeTelephone.Autre, name: translations['Parcs.Detail.Phones.Types.Autre'], icon: 'more' },
      ];
      this.TauxRemplissageSelection = [
        { value: 0, name: translations['Conteneurs.NiveauRemplissageValue.Empty'] },
        { value: 25, name: translations['Conteneurs.NiveauRemplissageValue.1/4'] },
        { value: 50, name: translations['Conteneurs.NiveauRemplissageValue.1/2'] },
        { value: 75, name: translations['Conteneurs.NiveauRemplissageValue.3/4'] },
        { value: 100, name: translations['Conteneurs.NiveauRemplissageValue.Full'] }
      ];
      this.DemandeManutentionStatut = [
        { value: DemandeManutentionStatutValues.Annule, name: translations['DemandeManutentionStatut.Annule'] },
        { value: DemandeManutentionStatutValues.Cloture, name: translations['DemandeManutentionStatut.Cloture'] },
        { value: DemandeManutentionStatutValues.EnAttente, name: translations['DemandeManutentionStatut.EnAttente'] },
        { value: DemandeManutentionStatutValues.EnCours, name: translations['DemandeManutentionStatut.EnCours'] },
        { value: DemandeManutentionStatutValues.EnDemande, name: translations['DemandeManutentionStatut.EnDemande'] },
        { value: DemandeManutentionStatutValues.Livre, name: translations['DemandeManutentionStatut.Livre'] }
      ];
      this.StatutCommande = [
        { value: CommandeStatut.Brouillon, name: translations['Stock.Commandes.Statuts.Brouillon'], icon: 'file' },
        { value: CommandeStatut.Envoye, name: translations['Stock.Commandes.Statuts.Envoye'], icon: 'message' },
        { value: CommandeStatut.Valide, name: translations['Stock.Commandes.Statuts.Valide'], icon: 'check' },
        { value: CommandeStatut.Prepare, name: translations['Stock.Commandes.Statuts.Prepare'], icon: 'check' },
        { value: CommandeStatut.Livre, name: translations['Stock.Commandes.Statuts.Livre'], icon: 'check' }
      ];
      this.TypeArticle = [
        { value: TypeArticle.UtilisationInterne, name: translations['Stock.Articles.Types.UtilisationInterne'] },
        { value: TypeArticle.PeutEtreVendu, name: translations['Stock.Articles.Types.PeutEtreVendu'] },
      ];
      return translations;
    }));
  }

  GetDefaultFilter(fieldName: string) {
    if (this.DefaultHeaderFilter != null) {
      this.DefaultHeaderFilter.map(a => a.value[0] = fieldName);
      return JSON.parse(JSON.stringify(this.DefaultHeaderFilter));
    } else {
      return [];
    }
  }

  GetActiveFilter(fieldName: string) {
    if (this.ActiveHeaderFilter != null) {
      this.ActiveHeaderFilter.map(a => a.value[0] = fieldName);
      return this.ActiveHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypeConteneurFilter(fieldName: string) {
    if (this.ConteneurMobileHeaderFilter != null) {
      this.ConteneurMobileHeaderFilter.map(cm => cm.value[0] = fieldName);
      return this.ConteneurMobileHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypePersonnePhysiqueFilter(fieldName: string) {
    if (this.PersonnePhysiqueHeaderFilter != null) {
      this.PersonnePhysiqueHeaderFilter.map(cm => cm.value[0] = fieldName);
      return this.PersonnePhysiqueHeaderFilter;
    } else {
      return [];
    }
  }

  GetEstExcluFilter() {
    let date = new Date(Date.now());
    let year = date.getFullYear();
    let month:any = date.getMonth()+1;
    let dt:any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let now = `${year}-${month}-${dt}`;
    this.EstExcluHeaderFilter = [{
        text: this.translate.instant('Yes'),
        value: [['DateDebutExclusion', '<', now], 'and', ['DateFinExclusion', '>', now], 'and', ['!', ['DateFinExclusion', '=', null]]]
      }, {
        text: this.translate.instant('No'),
        value: [['DateFinExclusion', '=', null], 'or', ['DateFinExclusion', '<', now]]
      }
    ];
    return this.EstExcluHeaderFilter;
  }

  GetSecondeResidenceFilter() {
    if (this.SecondeResidenceHeaderFilter != null) {
      return this.SecondeResidenceHeaderFilter;
    } else {
      return [];
    }
  }

  GetParcFilter(fieldName: string) {
    if (this.ParcHeaderFilter != null) {
      this.ParcHeaderFilter.map(p => p.value[0] = fieldName);
      return this.ParcHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypeCompteursFilter(fieldName: string) {
    if (this.TypeCompteurFilter != null) {
      this.TypeCompteurFilter.map(p => p.value[0] = fieldName);
      return this.TypeCompteurFilter;
    } else {
      return [];
    }
  }

  GetTypeAccesFilter(fieldName: string) {
    if (this.TypeAccesFilter != null) {
      this.TypeAccesFilter.map(p => p.value[0] = fieldName);
      return this.TypeAccesFilter;
    } else {
      return [];
    }
  }

  GetFormeJuridiqueFilter(fieldName: string) {
    if (this.FormeJuridiqueFilter != null) {
      this.FormeJuridiqueFilter.map(j => j.value[0] = fieldName);
      return this.FormeJuridiqueFilter;
    } else {
      return [];
    }
  }

  GetTypeDechetFilter(fieldName: string) {
    if (this.DechetTypeHeaderFilter != null) {
      this.DechetTypeHeaderFilter.map(dt => dt.value[0] = fieldName);
      return this.DechetTypeHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypeDechetIdFilter(fieldName: string) {
    if (this.TypeDechetIdHeaderFilter != null) {
      this.TypeDechetIdHeaderFilter.map(td => td.value[0] = fieldName);
      return this.TypeDechetIdHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypeEvacuationIdFilter(fieldName: string) {
    if (this.TypeEvacuationIdHeaderFilter != null) {
      this.TypeEvacuationIdHeaderFilter.map(td => td.value[0] = fieldName);
      return this.TypeEvacuationIdHeaderFilter;
    } else {
      return [];
    }
  }

  GetDemandeManutentionStatutFilter(fieldName: string) {
    if (this.DemandeManutentionStatutFilter != null) {
      this.DemandeManutentionStatutFilter.map(td => td.value[0] = fieldName);
      return this.DemandeManutentionStatutFilter;
    } else {
      return [];
    }
  }

  GetTypeArticleFilter() {
    if (this.TypeArticleFilter != null) {
      return this.TypeArticleFilter;
    } else {
      return [];
    }
  }

  GetTypeArticle() {
    if (this.TypeArticle != null) {
      return this.TypeArticle;
    } else {
      return [];
    }
  }
  GetEmplacementFilter(fieldName: string) {
    if (this.EmplacementHeaderFilter != null) {
      this.EmplacementHeaderFilter.map(p => p.value[0] = fieldName);
      return this.EmplacementHeaderFilter;
    } else {
      return [];
    }
  }

  GetStatutCommande() {
    if (this.StatutCommande != null) {
      return this.StatutCommande;
    } else {
      return [];
    }
  }

  GetStatutCommandeFilter() {
    if (this.StatutCommandeFilter != null) {
      return this.StatutCommandeFilter;
    } else {
      return [];
    }
  }

  GetStatutRapportFilter() {
    if (this.StatutRapportHeaderFilter != null) {
      return this.StatutRapportHeaderFilter;
    } else {
      return [];
    }
  }

  GetTypeInterventionFilter(fieldName: string) {
    if (this.TypeInterventionFilter != null) {
      this.TypeInterventionFilter.map(p => p.value[0] = fieldName);
      return this.TypeInterventionFilter;
    } else {
      return [];
    }
  }

  GetStatutInterventionFilter(fieldName: string) {
    if (this.StatutInterventionFilter != null) {
      this.StatutInterventionFilter.map(p => p.value[0] = fieldName);
      return this.StatutInterventionFilter;
    } else {
      return [];
    }
  }

  GetTypeDegatFilter(fieldName: string) {
    if (this.TypeDegatFilter != null) {
      this.TypeDegatFilter.map(p => p.value[0] = fieldName);
      return this.TypeDegatFilter;
    } else {
      return [];
    }
  }

  GetStatutNettoyageFilter(fieldName: string) {
    if (this.StatutNettoyageFilter != null) {
      this.StatutNettoyageFilter.map(p => p.value[0] = fieldName);
      return this.StatutNettoyageFilter;
    } else {
      return [];
    }
  }

  GetStatutEvacuationFilter(fieldName: string) {
    if (this.StatutEvacuationFilter != null) {
      this.StatutEvacuationFilter.map(p => p.value[0] = fieldName);
      return this.StatutEvacuationFilter;
    } else {
      return [];
    }
  }

  GetTypeDechetSelection() {
    if (this.DechetTypeSelection != null) {
      return this.DechetTypeSelection;
    } else {
      return [];
    }
  }

  GetTypeConteneurSelection() {
    if (this.ConteneurTypeSelection != null) {
      return this.ConteneurTypeSelection;
    } else {
      return [];
    }
  }

  GetTypeElementStockFilter(fieldName: string) {
    if (this.TypeElementStockFilter != null) {
      this.TypeElementStockFilter.map(p => p.value[0] = fieldName);
      return this.TypeElementStockFilter;
    } else {
      return [];
    }
  }

  GetLanguesSelection() {
    if (this.LangueSelection != null) {
      return this.LangueSelection;
    } else {
      return [];
    }
  }

  GetTypeTelephoneSelection() {
    if (this.TypeTelephoneSelection != null) {
      return this.TypeTelephoneSelection;
    } else {
      return [];
    }
  }

  GetTauxRemplissageSelection() {
    if (this.TauxRemplissageSelection != null) {
      return this.TauxRemplissageSelection;
    } else {
      return [];
    }
  }

  GetDemandeManutentionStatutSelection() {
    if (this.DemandeManutentionStatut != null) {
      return this.DemandeManutentionStatut;
    }
    else {
      return [];
    }
  }

  SetColor(params: ParametresGlobauxDto) {
    const styles = {
      color: params.SiteColor
    };
    return styles;
  }

  SetBackgroundColor(params: ParametresGlobauxDto) {
    const styles = {
      'background-color': params.SiteColor,
    };
    return styles;
  }

  GetVersion() {
    const promise = new Promise((resolve, reject) => {
      resolve(this.envService.version);
    });
    return promise;
  }

  GetLogo() {
    if (!!this.logo)
      return this.logo;
    return null;
  }

  GetFilteredCodesPostauxByNumber(numero: string): CodePostalDto[] {
    const codesPostaux = this.codesPostaux.filter(cp => cp.Code.startsWith(numero));
    return codesPostaux;
  }

  GetFilteredCodesPostauxByLocality(localite: string): CodePostalDto[] {
    const codesPostaux = this.codesPostaux.filter(cp => cp.Localite.startsWith(localite));
    return codesPostaux;
  }

  GetFilteredCodesPostauxById(id: number): CodePostalDto {
    const codePostal = this.codesPostaux.filter(cp => cp.Id == id);
    return codePostal.length == 1 ? codePostal[0] : null;
  }

  GetFilteredPaysByNom(nom: string): PaysDto[] {
    const pays = this.pays.filter(p => p.Nom.startsWith(nom));
    return pays;
  }

  GetFilteredPaysById(id: number): PaysDto {
    const pays = this.pays.filter(p => p.Id == id);
    return pays.length == 1 ? pays[0] : null;
  }

  GetMaxCharacters(value: string): string {
    return value.length >= this.MaxCharacters ? `${value.substring(0, this.MaxCharacters)}...` : value;
  }

  GetStatutIntervention(intervention: InterventionDto) : string {
    if (intervention == null || intervention.Statut == null) {
      return "";
    }

    switch (intervention.Statut) {
      case StatutIntervention.EnDemande:
        return this.Translations['Entretien.Interventions.Statuts.EnDemande'];
      case StatutIntervention.Validee:
        return this.Translations['Entretien.Interventions.Statuts.Validee'];
      case StatutIntervention.Planifiee:
        return this.Translations['Entretien.Interventions.Statuts.Planifiee'];
      case StatutIntervention.Effectuee:
        return this.Translations['Entretien.Interventions.Statuts.Effectuee'];
      case StatutIntervention.Annulee:
        return this.Translations['Entretien.Interventions.Statuts.Annulee'];
    }
  }

  GetStatutNettoyage(nettoyage: NettoyageDto) : string{
    if(nettoyage == null || nettoyage.Statut == null){
      return "";
    }

    switch(nettoyage.Statut){
      case StatutNettoyage.EnAttente:
        return this.Translations['Entretien.Nettoyage.Statuts.EnAttente'];
      case StatutNettoyage.EnCours:
        return this.Translations['Entretien.Nettoyage.Statuts.EnCours'];
      case StatutNettoyage.Terminee:
        return this.Translations['Entretien.Nettoyage.Statuts.Terminee'];
    }
  }
}
